module.exports = __webpack_public_path__ + "media/customizations/bryson/logo-5adb81f4d475178a66aa4c2048be4c8b.png";